import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./anim";

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`eyebrow ${className}`}>{children}</p>
);

export const CTAButton = ({
  to,
  children,
  variant = "solid",
  className = "",
  testId,
}) => {
  const base =
    "group inline-flex items-center gap-3 rounded-full px-7 py-4 text-[11px] md:text-xs font-semibold uppercase tracking-[0.2em] transition-colors duration-300";
  const variants = {
    solid: "bg-brand-orange text-brand-ink hover:bg-[#ff9433] shadow-[0_0_40px_rgba(255,121,0,0.25)]",
    outline:
      "border border-white/25 text-white hover:border-brand-orange hover:text-brand-orange",
    dark: "bg-brand-ink text-brand-ivory hover:bg-[#2a2a2a]",
    ivory: "bg-[#101010] text-[#F5F0E7] hover:bg-[#2a2a2a]",
  };
  return (
    <Link
      to={to}
      data-testid={testId}
      className={`${base} ${variants[variant]} ${className}`}
    >
      <span>{children}</span>
      <ArrowRight
        size={15}
        strokeWidth={2.4}
        className="transition-transform duration-300 group-hover:translate-x-1"
      />
    </Link>
  );
};

export const SectionTitle = ({ children, className = "" }) => (
  <h2
    className={`font-display font-semibold leading-[1.02] tracking-tight text-[clamp(2.4rem,5.5vw,4.6rem)] ${className}`}
  >
    {children}
  </h2>
);

export const Divider = ({ className = "" }) => (
  <Reveal className={`h-px w-full bg-white/[0.07] ${className}`} y={0}>
    <span className="block h-px w-full bg-white/[0.07]" />
  </Reveal>
);
